import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useApprovals() {
  const [approvals, setApprovals] = useState([]);
  const [loadingApprovals, setLoadingApprovals] = useState(true);

  const fetchApprovals = useCallback(async () => {
    setLoadingApprovals(true);
    try {
      const { data, error } = await supabase
        .from('agency_approvals')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;

      setApprovals(
        (data || []).map(a => ({
          id: a.id,
          postId: a.post_id,
          action: a.action,
          reviewerName: a.reviewer_name,
          notes: a.notes,
          createdAt: a.created_at,
        }))
      );
    } catch (err) {
      console.error('Error fetching approvals:', err);
    } finally {
      setLoadingApprovals(false);
    }
  }, []);

  useEffect(() => {
    fetchApprovals();
  }, [fetchApprovals]);

  const submitApproval = useCallback(async (postId, action, reviewerName, notes) => {
    const { error } = await supabase
      .from('agency_approvals')
      .insert({
        post_id: postId,
        action,
        reviewer_name: reviewerName,
        notes: notes || '',
      });
    if (error) throw error;
    await fetchApprovals();
  }, [fetchApprovals]);

  return { approvals, loadingApprovals, submitApproval, refetchApprovals: fetchApprovals };
}
